import { DotLegalSelectOption } from "@common/components/dotLegalMultiSelect/DotLegalMultiSelect.types";
import { setFirstLetterToLowerCase } from "@common/stringOperations";
import { LegalEntityContactType } from "../legalEntityContactTab/LegalEntityContactTab.types";

interface SelectableContact {
    id: string;
    name: string;
    email: string;
    contactTypes: Array<LegalEntityContactType>;
}

export function formatContactOptionName(contact: Pick<SelectableContact, "name" | "contactTypes">, translateString: (key: string) => string) {
    if (contact.contactTypes.length === 0) {
        return contact.name;
    }

    const contactTypeNames = contact.contactTypes.map((contactType) =>
        translateString(setFirstLetterToLowerCase(LegalEntityContactType[contactType].toString()))
    );
    return `${contact.name} (${contactTypeNames.join(", ")})`;
}

// The main contact already gets every email, so it is never offered as an additional recipient
export function getAdditionalRecipientOptions(
    contacts: Array<SelectableContact>,
    contactId: string | undefined,
    translateString: (key: string) => string
): Array<DotLegalSelectOption> {
    return contacts
        .filter((contact) => contact.id !== contactId)
        .map((contact) => ({ id: contact.id, name: formatContactOptionName(contact, translateString), hoverText: contact.email }));
}

export function withoutContact(additionalRecipientIds: Array<string>, contactId: string | undefined) {
    return additionalRecipientIds.filter((additionalRecipientId) => additionalRecipientId !== contactId);
}
